import React, { useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from "react-router-dom";
import { useFormik } from 'formik';
import { FaLock } from "react-icons/fa";
import { ToastContainer, toast } from 'react-toastify';
import Logo from "../assets/images/logo.webp";
import Authimg from '../assets/images/loginbg.png';
import { resetPasswordSchema } from '../schemas';
import { postForgotPasswordVerify } from '../apiservices/ApiServices';
import Loader from '../components/Loader/Loader';

const initialValues = {
    password: '',
    confirmpassword: '',
}

const ResetPassword = () => {
    const [isLoading, setLoading] = useState(false);
    const [isSuccess, setSuccess] = useState(false);
    const navigate = useNavigate();
    const { token } = useParams();

    useEffect(() => {
        setSuccess(false);
    }, [token])

    const postForgotPasswordVerifys = async (values, action) => {
        let postdata =
        {
            'token': token,
            'new_password': values.password,
            'confirm_password': values.confirmpassword,
        }
        try {
            const res = await postForgotPasswordVerify(postdata);
            toast.success(res.data.message);
            setSuccess(false);
            action.resetForm();
            setLoading(false);
            setTimeout(() => navigate("/login"), 3000);
        } catch (error) {
            setSuccess(true);
            toast.error(error.response.data.message);
            console.log(error.response.data.data);
            setLoading(false);
        }
    };

    const { values, errors, touched, handleBlur, handleChange, handleSubmit } = useFormik({
        initialValues: initialValues,
        validationSchema: resetPasswordSchema,
        onSubmit: (values, action) => {
            setLoading(true);
            postForgotPasswordVerifys(values, action);
        }
    })

    return (
        <section id='auth'>
            <ToastContainer />
            <div className='auth-block'>
                <div className='auth-imgshap'>
                    <div className='auth-img'>
                        <img src={Authimg} alt='authimage' />
                    </div>
                </div>
                <div className='auth-froms'>
                    <div className='authboxs'>
                        <div className='logoimgs'>
                            <Link to={'/'}>
                                <img src={Logo} alt='' title='' />
                            </Link>
                        </div>
                        <div className='forms_boxs'>
                            <div className='titles'>
                                <h2>Reset Password </h2>
                                <p>(as part of set new Password)</p>
                            </div>
                            <form id='forgotpassform' onSubmit={handleSubmit} autoComplete="off">
                                <div className='form-group'>
                                    <div className="control has-icon">
                                        <label className="label auth-label" htmlFor="v-field-2">Password</label>
                                        <input type="password"
                                            id="password"
                                            name="password"
                                            className="input v-input"
                                            autoComplete='off'
                                            value={values.password}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                        {errors.password && touched.password ? (
                                            <p className='errormsg'>{errors.password}</p>
                                        ) : null}
                                        <label className="label form-icon" htmlFor="v-field-1">
                                            <FaLock />
                                        </label>
                                    </div>
                                </div>
                                <div className='form-group'>
                                    <div className="control has-icon">
                                        <label className="label auth-label" htmlFor="v-field-2">Confirm Password</label>
                                        <input type="password"
                                            id="confirmpassword"
                                            name="confirmpassword"
                                            className="input v-input"
                                            autoComplete='off'
                                            value={values.confirmpassword}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                        {errors.confirmpassword && touched.confirmpassword ? (
                                            <p className='errormsg'>{errors.confirmpassword}</p>
                                        ) : null}
                                        <label className="label form-icon" htmlFor="v-field-1">
                                            <FaLock />
                                        </label>
                                    </div>
                                </div>
                                {isSuccess ? (
                                    <div className='form-group'>
                                        <div className="control is-flex space">
                                            <p>Send New Email Request <Link className='links' to={'/forgot-password'}>Forgot Password</Link></p>
                                        </div>
                                    </div>
                                ) : null}
                                <div className='buttonbox'>
                                    <button type='submit' className='btn btn-orange'>Submit</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            {isLoading ? (
                <Loader />
            ) : null}
        </section>
    );
}

export default ResetPassword